var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Badge, Box, Button, Checkbox, FormControlLabel, Hidden, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Typography, } from "@material-ui/core";
import { Add, Delete } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import { usePagination } from "frontend/src/lib/pagination";
import { AudioControlButton } from "frontend/src/ui/audio-control-button";
import { usePlayerTrackId } from "frontend/src/domain/player-track-queue";
import { useIsAudioLoading, useIsAudioPlaying, } from "frontend/src/domain/audio";
import { resume, pause } from "frontend/src/features/control-audio";
import { playSearchResultAttempted } from "frontend/src/features/play-search-result";
import { TrackTableRow } from "frontend/src/ui/track-table-row";
import { useTableSort, } from "frontend/src/pages/routes/admin/tracks/index/model/use-table-sort";
import { useTracksSearchResult } from "../selectors";
var headCells = [
    { id: "title", label: "Название", isSortable: true },
    { id: "artist", label: "Исполнитель", isSortable: true },
    { id: "genres", label: "Жанры", isSortable: true },
    { id: "duration", label: "Длительность", isSortable: true },
    { id: "created_at", label: "Дата", isSortable: true },
    { id: "ISRC", label: "ISRC", isSortable: true },
    { id: "is_normalized", label: "Норм.", isSortable: true },
    { id: "is_approved", label: "Одобрен?", isSortable: true },
];
var formatTrackDate = function (value) {
    if (!value) {
        return "-";
    }
    return new Intl.DateTimeFormat("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).format(new Date(value));
};
export var SearchCatalogResult = function (_a) {
    var params = _a.params, addedTrackCounter = _a.addedTrackCounter, onTrackAdd = _a.onTrackAdd, onTracksAdd = _a.onTracksAdd, onTrackRemove = _a.onTrackRemove, _b = _a.showAdminColumns, showAdminColumns = _b === void 0 ? true : _b, _c = _a.showIsrcToggle, showIsrcToggle = _c === void 0 ? true : _c;
    var _d = useTableSort(), onSort = _d.onSort, sortBy = _d.sortBy, orderBy = _d.orderBy;
    var _e = React.useState(false), showIsrc = _e[0], setShowIsrc = _e[1];
    var visibleHeadCells = headCells.filter(function (headCell) {
        if (!showAdminColumns && ["is_normalized", "is_approved"].includes(headCell.id)) {
            return false;
        }
        if (headCell.id === "ISRC") {
            return showIsrcToggle && showIsrc;
        }
        return true;
    });
    var _f = usePagination({
        page: 0,
        rowsPerPage: 25,
        pageResetDeps: [params, sortBy, orderBy],
    }), page = _f.page, skip = _f.skip, rowsPerPage = _f.rowsPerPage, onChangeRowsPerPage = _f.onChangeRowsPerPage, onChangePage = _f.onChangePage;
    var _g = useTracksSearchResult({
        params: __assign(__assign({}, params), { limit: rowsPerPage, offset: skip, sortBy: sortBy, orderBy: orderBy }),
    }), data = _g.data, isLoading = _g.isLoading, isFetching = _g.isFetching;
    var _h = React.useState({}), checkedTracks = _h[0], setCheckedTracks = _h[1];
    var visibleTrackIds = React.useMemo(function () { return (data === null || data === void 0 ? void 0 : data.tracks.map(function (track) { return track.id; })) || []; }, [data === null || data === void 0 ? void 0 : data.tracks]);
    var checkedIds = React.useMemo(function () { return Object.keys(checkedTracks).map(function (id) { return parseInt(id); }); }, [checkedTracks]);
    var checkedTracksList = React.useMemo(function () {
        return (data === null || data === void 0 ? void 0 : data.tracks.filter(function (track) { return checkedTracks[track.id]; })) || [];
    }, [checkedTracks, data === null || data === void 0 ? void 0 : data.tracks]);
    var visibleCheckedCount = visibleTrackIds.filter(function (id) { return checkedTracks[id]; })
        .length;
    var isAllVisibleChecked = visibleTrackIds.length > 0 && visibleCheckedCount === visibleTrackIds.length;
    var isSomeVisibleChecked = visibleCheckedCount > 0 && visibleCheckedCount < visibleTrackIds.length;
    var toggleTrack = function (id) {
        setCheckedTracks(function (current) {
            var _a;
            if (current[id]) {
                var _b = current, _c = id, _ = _b[_c], rest = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
                return rest;
            }
            return __assign(__assign({}, current), (_a = {}, _a[id] = true, _a));
        });
    };
    var toggleVisibleTracks = function () {
        if (isAllVisibleChecked) {
            setCheckedTracks(function (current) {
                return visibleTrackIds.reduce(function (acc, id) {
                    var _a = acc, _b = id, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                    return rest;
                }, __assign({}, current));
            });
            return;
        }
        setCheckedTracks(function (current) {
            return visibleTrackIds.reduce(function (acc, id) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[id] = true, _a)));
            }, __assign({}, current));
        });
    };
    var addCheckedTracks = function () {
        if (checkedTracksList.length > 0) {
            onTracksAdd === null || onTracksAdd === void 0 ? void 0 : onTracksAdd(checkedTracksList);
            setCheckedTracks({});
        }
    };
    React.useEffect(function () {
        setCheckedTracks({});
    }, [params.search, params.genres, sortBy, orderBy, page, rowsPerPage]);
    var play = function (_a) {
        var selected = _a.selected, id = _a.id;
        if (data) {
            if (selected) {
                resume();
            }
            else {
                playSearchResultAttempted({
                    tracks: data.tracks,
                    startAtTrackIndex: data.tracks.findIndex(function (track) { return track.id === id; }),
                });
            }
        }
    };
    var selectedTrackId = usePlayerTrackId();
    var isAudioPlaying = useIsAudioPlaying();
    var isAudioLoading = useIsAudioLoading();
    if (!isLoading && !isFetching && (data === null || data === void 0 ? void 0 : data.tracks.length) === 0) {
        return React.createElement(Typography, null, "\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0440\u0435\u043A\u0430.");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { component: Paper, p: 2, mb: 1, display: "flex", alignItems: "center" },
            React.createElement(Typography, { color: "textSecondary" },
                "\u0412\u044B\u0431\u0440\u0430\u043D\u043E \u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435: ",
                checkedIds.length),
            React.createElement(Box, { ml: 2 },
                React.createElement(Button, { color: "primary", variant: "outlined", disabled: checkedIds.length === 0 || !onTracksAdd, onClick: addCheckedTracks }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0432 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442")),
            showIsrcToggle && (React.createElement(Box, { ml: "auto" },
                React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: showIsrc, onChange: function (evt) { return setShowIsrc(evt.target.checked); }, color: "primary" }), label: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C ISRC" })))),
        React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, null,
                React.createElement(Hidden, { xsDown: true },
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null,
                                React.createElement(Checkbox, { checked: isAllVisibleChecked, indeterminate: isSomeVisibleChecked, onChange: toggleVisibleTracks, color: "primary", inputProps: {
                                        "aria-label": "Выделить все треки на странице",
                                    } })),
                            React.createElement(TableCell, null),
                            visibleHeadCells.map(function (headCell) { return (React.createElement(TableCell, { key: headCell.id, sortDirection: sortBy === headCell.id
                                    ? orderBy
                                    : false }, headCell.isSortable ? (React.createElement(TableSortLabel, { active: sortBy === headCell.id, direction: sortBy === headCell.id
                                    ? orderBy
                                    : "asc", onClick: function () { return onSort(headCell.id); } }, headCell.label)) : (headCell.label))); }),
                            React.createElement(TableCell, null),
                            React.createElement(TableCell, null)))),
                React.createElement(TableBody, null,
                    data &&
                        data.tracks.map(function (track) {
                            var addCounter = addedTrackCounter[track.id];
                            var isAdded = typeof addCounter === "number";
                            var selected = selectedTrackId === track.id;
                            var playing = isAudioPlaying && selected;
                            var loading = isAudioLoading && selected;
                            var onPlay = function () { return play({ id: track.id, selected: selected }); };
                            return (React.createElement(TrackTableRow, { key: track.id, isSelectedForPlayer: selected },
                                React.createElement(TableCell, null,
                                    React.createElement(Checkbox, { checked: Boolean(checkedTracks[track.id]), onChange: function () { return toggleTrack(track.id); }, color: "primary" })),
                                React.createElement(TableCell, null,
                                    React.createElement(AudioControlButton, { isLoading: loading, onPause: pause, onPlay: onPlay, isPlaying: playing })),
                                React.createElement(TableCell, null, track.title),
                                React.createElement(TableCell, null, track.artist),
                                React.createElement(TableCell, null, track.genres.map(function (genre) { return genre.title; }).join(", ")),
                                React.createElement(TableCell, null, track.duration.formatted),
                                React.createElement(TableCell, null, formatTrackDate(track.createdAt)),
                                showIsrcToggle && showIsrc && React.createElement(TableCell, null, track.ISRC),
                                showAdminColumns && (React.createElement(React.Fragment, null,
                                    React.createElement(TableCell, null, track.isNormalized ? "Да" : "Нет"),
                                    React.createElement(TableCell, null, track.isApproved ? "Да" : "Нет"))),
                                React.createElement(TableCell, null,
                                    React.createElement(IconButton, { size: "small", onClick: function () { return onTrackAdd(track); } },
                                        React.createElement(Add, null))),
                                React.createElement(TableCell, null, isAdded ? (React.createElement(Box, null,
                                    React.createElement(Badge, { badgeContent: addCounter, color: "secondary", invisible: addCounter < 2 },
                                        React.createElement(IconButton, { size: "small", onClick: function () { return onTrackRemove(track.id); } },
                                            React.createElement(Delete, null))))) : (React.createElement(Box, { height: 30, width: 30 })))));
                        }),
                    isLoading &&
                        Array.from({ length: rowsPerPage }).map(function (_, index) { return (React.createElement(TableRow, { key: index }, Array.from({
                            length: 4 +
                                visibleHeadCells.length,
                        }).map(function (__, number) { return (React.createElement(TableCell, { key: number },
                            React.createElement(Skeleton, null))); }))); })))),
        data && (React.createElement(TablePagination, { component: Paper, count: data.total, page: page, onPageChange: onChangePage, rowsPerPage: rowsPerPage, onRowsPerPageChange: onChangeRowsPerPage, labelRowsPerPage: "Выбрано треков" }))));
};
